import { TextJson } from '../interfaces/Text.json';
import { Text } from '../Text';

export class TextFactory {
  public static build(data: TextJson): Text {
    return new Text(data.value, data.type, data.sentAt, data.key);
  }
}
